import { trackAppStoreClick } from "./metrics";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const APP_STORE_URL = "https://apps.apple.com/jp/app/id6469480108";

function Home() {
  useEffect(() => {
    const id = window.location.hash.replace(/^#/, "");
    if (!id) return;
    document.getElementById(id)?.scrollIntoView();
  }, []);

  return (
    <div className="home">
      <header>
        <div className="w hd">
          <Link className="logo" to="/">
            <img src="/aelios-lockup.svg" alt="Aelios" />
          </Link>
          <nav aria-label="ページ内">
            <a href="#p">Projects</a>
            <a href="#idea">Ideas</a>
            <a href="#c">Company</a>
            <a href="#q" className="nb">
              お問い合わせ
            </a>
          </nav>
        </div>
      </header>

      <section className="hero">
        <div className="w">
          <div className="hero-mark" aria-hidden="true">
            <svg viewBox="-36.60 -28.45 84.61 84.61">
              <defs>
                <linearGradient id="aelios-sun" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stopColor="#ffc9a8" />
                  <stop offset="1" stopColor="#f08fc6" />
                </linearGradient>
              </defs>
              <circle cx="0.00" cy="0.00" r="13.00" fill="url(#aelios-sun)" />
              <circle cx="-1.83" cy="-20.92" r="3.00" fill="#8fa2ff" />
              <circle cx="19.75" cy="-18.41" r="4.80" fill="#9b6bd9" />
              <circle cx="32.59" cy="5.16" r="6.60" fill="#e59bd9" />
              <circle cx="18.91" cy="34.11" r="8.40" fill="#8fa2ff" />
              <circle cx="-17.58" cy="41.42" r="10.20" fill="#9b6bd9" />
            </svg>
          </div>
          <p className="ey">AELIOS</p>
          <h1>
            まだ誰も気づいていない価値を、<wbr />探しにいく。
          </h1>
          <p className="lead">
            当たり前になっている不便の奥に、新しい価値が眠っている。Aeliosは問いを立て、形にし、確かめながら、その答えを探しています。
          </p>
          <div className="cta">
            <a className="btn" href="#p">
              プロダクト
            </a>
            <a className="btn o" href="#idea">
              面倒を教える
            </a>
          </div>
        </div>
      </section>

      <section id="p">
        <div className="w">
          <div className="sh">
            <p className="ey">Projects</p>
            <h2>プロダクト</h2>
          </div>
          <div className="feat">
            <article className="card fc">
              <div className="ft">
                <span className="tag">iOSアプリ</span>
                <span className="badge live">App Storeで公開中</span>
                <h3>ととのう固定費</h3>
                <p>毎月の固定費をととのえるiOSアプリ。</p>
                <a href={APP_STORE_URL} onClick={() => trackAppStoreClick("home_product")}>App Storeで見る →</a>
              </div>
              <div className="fv">
                <div className="ph">
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="/totonou-icon-256.webp 256w, /totonou-icon-512.webp 512w"
                      sizes="152px"
                    />
                    <img
                      className="app-icon"
                      src="/totonou-icon-512.png"
                      srcSet="/totonou-icon-256.png 256w, /totonou-icon-512.png 512w"
                      sizes="152px"
                      width={152}
                      height={152}
                      alt="ととのう固定費のアプリアイコン"
                    />
                  </picture>
                </div>
              </div>
            </article>
            <article className="card fc ecocute-product">
              <div className="ft">
                <span className="tag">契約前の見積チェック</span>
                <h3>エコキュート見積の契約前チェック</h3>
                <p>交換の見積、サインする前に。売る側ではない立場で、内訳と確認点を一緒に整理します。</p>
                <a href="/ecocute-check/">料金と対応範囲・無料チェックを見る →</a>
              </div>
              <div className="fv" aria-hidden="true">
                <div className="ph">
                  <svg className="quote-icon" viewBox="0 0 160 160" fill="none">
                    <rect x="35" y="20" width="90" height="120" rx="18" fill="white" stroke="#9b6bd9" strokeWidth="3" />
                    <path d="M56 48h48M56 66h30M56 84h22" stroke="#b6bfe9" strokeWidth="6" strokeLinecap="round" />
                    <circle cx="106" cy="108" r="25" fill="#dcfaf0" stroke="#5b6bd0" strokeWidth="3" />
                    <path d="m94 108 8 8 16-18" stroke="#5b6bd0" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section id="idea">
        <div className="w narrow">
          <div className="sh">
            <p className="ey">Ideas</p>
            <h2>あなたの悩みも、形にできるかもしれない。</h2>
          </div>
          <div className="card invite">
            <p>
              日々の「ちょっと面倒」や「こんなのがあったらいいのに」を教えてください。
            </p>
            <a className="btn" href="#q">
              こんな面倒を教えてください
            </a>
          </div>
        </div>
      </section>

      <section id="c">
        <div className="w narrow">
          <div className="sh">
            <p className="ey">Company</p>
            <h2>会社概要</h2>
          </div>
          <dl>
            <dt>会社名</dt>
            <dd>Aelios</dd>
            <dt>代表者</dt>
            <dd>作田 陽樹</dd>
            <dt>設立</dt>
            <dd>2022年5月1日</dd>
            <dt>電話番号</dt>
            <dd>070-3788-6007</dd>
          </dl>
        </div>
      </section>

      <section id="q" className="ct">
        <div className="w narrow">
          <div className="sh">
            <p className="ey">Contact</p>
            <h2>お問い合わせ</h2>
          </div>
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <label>
              お名前
              <input name="name" autoComplete="name" placeholder="山田 太郎" />
            </label>
            <label>
              メールアドレス
              <input
                name="email"
                type="email"
                autoComplete="email"
                placeholder="you@example.com"
              />
            </label>
            <label>
              お問い合わせ種別
              <select name="topic" defaultValue="idea">
                <option value="idea">「こんな面倒を解いてほしい」</option>
                <option value="totonou">ととのう固定費について</option>
                <option value="press">取材・提携のご相談</option>
                <option value="other">その他</option>
              </select>
            </label>
            <label>
              お問い合わせ内容
              <textarea name="message" rows={5} placeholder="ご用件をご記入ください" />
            </label>
            <p id="contact-status" className="prep">
              準備中
            </p>
            <button
              className="btn"
              type="submit"
              disabled
              aria-describedby="contact-status"
            >
              送信する
            </button>
          </form>
        </div>
      </section>

      <footer>
        <div className="w">
          <div className="fg">
            <div>
              <img className="footer-logo" src="/aelios-lockup.svg" alt="Aelios" />
              <p>© Aelios</p>
              <a href="https://www.instagram.com/_saku_ta/">Instagram</a>
            </div>
            <div>
              <h4>ととのう固定費</h4>
              <a href={APP_STORE_URL} onClick={() => trackAppStoreClick("home_footer")}>App Store</a>
              <Link to="/money/terms">利用規約</Link>
              <Link to="/money/privacy_policy">プライバシーポリシー</Link>
              <Link to="/money/fee">料金について</Link>
              <Link to="/money/withdrawal">サブスクリプション解約</Link>
              <Link to="/money/delete_app">アプリ削除／<wbr />アカウント削除</Link>
            </div>
            <div>
              <h4>MISSION</h4>
              <Link to="/mission/terms">利用規約</Link>
              <Link to="/mission/privacy_policy">プライバシーポリシー</Link>
              <Link to="/mission/fee">料金について</Link>
              <Link to="/mission/delete_app">アプリ削除について</Link>
            </div>
            <div>
              <h4>ToDo</h4>
              <Link to="/todo/terms">利用規約</Link>
              <Link to="/todo/privacy_policy">プライバシーポリシー</Link>
              <Link to="/todo/delete_app">アカウント削除について</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
